import SamlSetup from './SamlSetup'

export default SamlSetup
